<template>
  <v-row justify="start">
    <v-col cols="11" align-self="center" class="border-bottom-success-1px pb-8">
      <slot name="topHeader"></slot>
    </v-col>
    <v-col cols="1" align-self="start" class="d-flex justify-start">
      <slot name="topHeaderSide"></slot>
    </v-col>
    <v-col
      :cols="showModalSpot ? 6 : 10"
      :md="showModalSpot ? 5 : 10"
      :lg="lgMainBodyBreakPoint"
      :xl="showModalSpot ? 7 : 10"
      align-self="start"
      class="d-flex justify-center pa-1"
    >
      <slot name="mainBody"></slot>
    </v-col>
    <v-col
      cols="4"
      md="5"
      lg="4"
      xl="3"
      align-self="center"
      class="d-flex justify-center pa-1"
      v-if="showModalSpot"
    >
      <slot name="modalSpot"></slot>
    </v-col>
    <v-col cols="2" align-self="center" class="d-flex justify-end">
      <slot name="desktopFooter"></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DesktopBodyLayout",
  props: {
    showModalSpot: Boolean,
    required: false,
    default: true,
  },
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    lgMainBodyBreakPoint() {
      if (this.showModalSpot) {
        switch (true) {
          case this.screenWidth > 1264 && this.screenWidth < 1399:
            return 5;
          default:
            return 6;
        }
      } else {
        return 10;
      }
    },
    lgDesktopFooterBreakPoint() {
      switch (true) {
        case this.screenWidth > 1264 && this.screenWidth < 1399:
          return 3;
        default:
          return 2;
      }
    },
    // lgTopHeaderSideBreakPoint() {
    //   const screenWidth = window.innerWidth;
    //   switch (true) {
    //     case screenWidth > 1264 && screenWidth < 1300:
    //       return 1;
    //     default:
    //       return 1;
    //   }
    // },
    // lgTopHeaderBreakPoint() {
    //   const screenWidth = window.innerWidth;
    //   switch (true) {
    //     case screenWidth > 1264 && screenWidth < 1300:
    //       return 11;
    //     default:
    //       return 11;
    //   }
    // },
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped></style>
